export const SORT_OPTIONS = [
  { labelKey: 'sort_price_asc', id: 'price-asc' },
  { labelKey: 'sort_price_desc', id: 'price-desc' },
  { labelKey: 'sort_distance_asc', id: 'distance-asc' },
  { labelKey: 'sort_distance_desc', id: 'distance-desc' }
] as const;

export type SortKeys = (typeof SORT_OPTIONS)[number]['id'];
